import { DateTimeDetailValue } from "../../../../components/shared/details-cells/DateTimeDetailValue";
import DetailsCells from "../../../../components/shared/details-cells/DetailsCells";
import COMMON_LOGS_DATA_MODEL from "../../../../utils/constants/commonLogsDataModel";
import RunStatusLabel from "../../common-for-log-sheet-and-run-logs/RunStatusLabel";
import ActionLogFileList from "../../ActionLogFileList";
import ActionLogLinkDetailView from "../../ActionLogLinkDetailView";
import {
  ApproverUserNameCluster,
  Flex,
  RunLogWrapper,
  CustomDetailsCellStyled,
  MediaTypeCell,
  GxpReadyCell,
  SystemStatusCell,
  CreatedAtCell,
  CreatedTimeAtCell,
  GxpRelevantCell
} from "../../common-for-log-sheet-and-run-logs/table-common-meta-info";
import ValueOrFallbackText from "../../common-for-log-sheet-and-run-logs/ValueOrFallbackText";
import { getDateTimeDisplay, getDateTimeDetailProps, valueOrEmpty } from "../../../../utils/helpers/text";
import RUN_LOGS_DATA_MODEL from "./../../../../utils/constants/runLogsDataModel";
import { DESCRIPTION_FIELD } from "../../../../utils/constants/descriptionField";

export const RunLogClusterTableMeta = {
  expandable: true,
  ExpandedComponent: ({ item, infoMeta }) => (
    <Flex>
      <DetailsCells Wrapper={RunLogWrapper} item={item} infoMeta={infoMeta} CellWrapper={CustomDetailsCellStyled} />
    </Flex>
  ),
  // expanded element from chevron click for main run log table view for clusters
  expandedComponentProps: {
    infoMeta: {
      fields: [
        {
          label: COMMON_LOGS_DATA_MODEL.createdAtTime.value,
          component: CreatedTimeAtCell
        },
        {
          label: RUN_LOGS_DATA_MODEL.startDate.value,
          component: ({ item }) => (
            <DateTimeDetailValue
              {...getDateTimeDetailProps(item, "runStartDateTime", "runStartDate", "runStartTime")}
            />
          )
        },
        {
          label: RUN_LOGS_DATA_MODEL.runEndDate.value,
          component: ({ item }) => (
            <DateTimeDetailValue {...getDateTimeDetailProps(item, "runEndDateTime", "runEndDate", "runEndTime")} />
          )
        },
        {
          label: RUN_LOGS_DATA_MODEL.gxpReady.value,
          component: GxpReadyCell
        },
        {
          label: RUN_LOGS_DATA_MODEL.systemStatus.value,
          component: SystemStatusCell
        },
        {
          label: COMMON_LOGS_DATA_MODEL.gxpRelevant.value,
          component: GxpRelevantCell
        },
        {
          label: RUN_LOGS_DATA_MODEL.samplesProcessed.value,
          field: ["samplesProcessed"]
        },
        {
          label: RUN_LOGS_DATA_MODEL.numberOfRuns.value,
          field: ["numberOfRuns"]
        },
        {
          label: RUN_LOGS_DATA_MODEL.defectId.value,
          field: ["defectId"]
        },
        {
          label: COMMON_LOGS_DATA_MODEL.operatorUserName.value,
          field: ["operatorUserName"]
        },
        {
          label: RUN_LOGS_DATA_MODEL.runIdentification.value,
          field: ["runIdentification"]
        },
        {
          label: RUN_LOGS_DATA_MODEL.gxpRelevantRun.value,
          field: ["gxpRelevantRun"]
        },
        {
          label: RUN_LOGS_DATA_MODEL.eLNid.value,
          field: ["eLNid"]
        },
        {
          label: RUN_LOGS_DATA_MODEL.tipsUsed.value,
          component: ({ item }) => (
            <ValueOrFallbackText reduxPath={["runLogsForm", "tips"]} item={item.tipsUsed} defaultValue="-" />
          )
        },
        {
          label: RUN_LOGS_DATA_MODEL.mediaType.value,
          component: MediaTypeCell
        },
        {
          label: RUN_LOGS_DATA_MODEL.assay.value,
          component: ({ item }) => <span>{item.assay && item.assay.length > 0 ? item.assay.join(", ") : "-"}</span>,
          props: {
            expand: true
          }
        },
        {
          label: RUN_LOGS_DATA_MODEL.gxpRelevantRun.value,
          field: ["gxpRelevantRun"]
        },
        {
          lookapVal: "attachments",
          field: ["attachments"],
          props: { style: { width: "50%" } },
          component: ({ item }) => <ActionLogFileList attachments={item.attachments} />
        },
        {
          field: ["externalDocument"],
          lookapVal: "externalDocument",
          props: { style: { width: "50%" } },
          component: ({ item }) => <ActionLogLinkDetailView externalDocuments={item?.externalDocument} />
        },
        DESCRIPTION_FIELD
      ]
    }
  },
  fields: {
    detailExpander: {
      text: ""
    },
    runStartDate: {
      sortable: true,
      text: RUN_LOGS_DATA_MODEL.runStartDate.value,
      component: ({ item }) => getDateTimeDisplay(item, "runStartDateTime", "runStartDate")
    },
    createdAt: {
      sortable: true,
      text: COMMON_LOGS_DATA_MODEL.createdAt.value,
      component: CreatedAtCell
    },
    runEndDate: {
      sortable: true,
      text: RUN_LOGS_DATA_MODEL.runEndDate.value,
      component: ({ item }) => (
        <DateTimeDetailValue {...getDateTimeDetailProps(item, "runEndDateTime", "runEndDate", "runEndTime")} />
      )
    },
    eLNid: {
      text: RUN_LOGS_DATA_MODEL.eLNid.value,
      component: ({ item }) => valueOrEmpty(item?.eLNid, false, "-")
    },
    runStatus: {
      text: RUN_LOGS_DATA_MODEL.runStatus.value,
      component: RunStatusLabel
    },
    runIdentification: {
      text: RUN_LOGS_DATA_MODEL.runIdentification.value
    },
    gxpRelevantRun: {
      text: RUN_LOGS_DATA_MODEL.gxpRelevantRun.value
    },
    gxpReady: {
      text: RUN_LOGS_DATA_MODEL.gxpReady.value,
      component: GxpReadyCell
    },
    systemStatus: {
      text: RUN_LOGS_DATA_MODEL.systemStatus.value,
      component: SystemStatusCell
    },
    gxpRelevant: {
      text: COMMON_LOGS_DATA_MODEL.gxpRelevant.value,
      component: GxpRelevantCell
    },
    ...ApproverUserNameCluster,
    description: {
      text: RUN_LOGS_DATA_MODEL.description.value
    },
    samplesProcessed: {
      text: RUN_LOGS_DATA_MODEL.samplesProcessed.value
    },
    numberOfRuns: {
      text: RUN_LOGS_DATA_MODEL.numberOfRuns.value
    },
    defectId: {
      text: RUN_LOGS_DATA_MODEL.defectId.value
    },
    operatorUserName: {
      text: COMMON_LOGS_DATA_MODEL.operatorUserName.value
    },
    tipsUsed: {
      text: RUN_LOGS_DATA_MODEL.tipsUsed.value,
      component: ({ item }) => (
        <ValueOrFallbackText reduxPath={["runLogsForm", "tips"]} item={item.tipsUsed} defaultValue="-" />
      )
    },
    mediaType: {
      text: RUN_LOGS_DATA_MODEL.mediaType.value,
      component: MediaTypeCell
    },
    assay: {
      text: RUN_LOGS_DATA_MODEL.assay.value,
      component: ({ item }) => <span>{item.assay && item.assay.length > 0 ? item.assay.join(", ") : "-"}</span>
    },
    subEquipment: {
      text: COMMON_LOGS_DATA_MODEL.subEquipment.value
    }
  }
};

export const runLogTabletSizes = {
  runStartDate: "0 1 10%",
  createdAt: "0 1 10%",
  runEndDate: "0 1 10%",
  subEquipment: "0 1 15%",
  eLNid: "0 1 10%",
  runStatus: "0 1 8%",
  runIdentification: "0 1 10%",
  gxpReady: "0 1 8%",
  systemStatus: "0 1 8%",
  gxpRelevant: "0 1 8%",
  equipmentModel: "0 1 10%",
  equipmentNickName: "0 1 10%",
  description: "0 1 15%",
  approverUserName: "0 1 8%",
  actionButtons: "0 0 132px"
};

export const runLogRegularSizes = {
  runStartDate: "0 1 10%",
  createdAt: "0 1 10%",
  runEndDate: "0 1 10%",
  subEquipment: "0 1 15%",
  eLNid: "0 1 10%",
  runStatus: "0 1 8%",
  runIdentification: "0 1 10%",
  gxpReady: "0 1 8%",
  systemStatus: "0 1 8%",
  gxpRelevant: "0 1 8%",
  equipmentModel: "0 1 10%",
  equipmentNickName: "0 1 10%",
  description: "0 1 15%",
  approverUserName: "0 1 8%",
  actionButtons: "0 0 132px"
};

export default RunLogClusterTableMeta;
